<div
  class="w-full h-full flex flex-col"
  mgEnterHostViewport
  (visibilityChange)="isVisible = $event; setSizes()"
>
  @for (item of info; track $index; let i = $index) {
    <div
      class="{{
        item.bgColorClass
      }} h-[10px] rounded-r-full mt-sm first:mt-0 transition-[width] duration-1000"
      [style.width.%]="animatable ? sizes[i] : item.size"
    ></div>

    @if (item.secondarySize !== undefined && item.secondarySize !== null) {
      <div
        class="{{
          item.borderColorClass
        }} -mt-xs h-[10px] border border-dashed transition-[width] duration-1000"
        [style.width.%]="animatable ? secondarySizes[i] : item.secondarySize"
      ></div>
    }
  }
</div>
